import React from 'react';
import bannerImage from "../img/aaaservices/info.jpg";
import brochure from '../img/TOOL & FIXURE DESIGN BROCHURE V3.pdf';

import Reactall from './Reactall';

const Puthonpage = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = brochure;
    link.download = 'Brochure.pdf';
    link.click();
  };

  const handleEnquiry = () => {
    console.log("Enquiry button clicked");
  };

  return (
    <div>
      {/* Banner Image */}
      {/* <div>
        <img
          src={bannerImage}
          alt="Banner"
          style={{ width: '100%', height: 'auto', maxHeight: '530px', objectFit: 'cover' }}
        />
      </div> */}
{/* 
      <PCMobileApplications /> */}
      
      <Reactall/>
    </div>
  );
};

export default Puthonpage;